var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
const getAllRoles = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Roles/get-all-roles", query);
    return response;
});
const createNewRole = (roleData) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Roles/create-new-role", roleData);
    return response;
});
const updateRole = (roleData) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put("Roles/update-role", roleData);
    return response;
});
const deleteRole = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.delete(`Roles/delete-role/${id}`);
    return response;
});
const toggleRoleStatus = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.patch("Roles/toggle-role-status", data);
    return response;
});
const getAllRolesSummary = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Roles/get-all-roles-summary");
    return response;
});
const getRolesDropdown = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Roles/get-roles-dropdown");
    return response;
});
const getRoleById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`Roles/get-role-by-id/${id}`);
    return response;
});
export const rolesApi = {
    getAllRoles,
    createNewRole,
    updateRole,
    deleteRole,
    toggleRoleStatus,
    getAllRolesSummary,
    getRolesDropdown,
    getRoleById,
};
